import { Controller, useFormContext } from 'react-hook-form';

import { Radio } from '../Radio';
import { RadioGroup, RadioGroupProps } from '../RadioGroup';

export type RadioOptionValueType = string | number;

export interface FormRadioGroupProps extends Omit<RadioGroupProps, 'selectedIndex' | 'onChange'> {
	name: string;
	options: { label: string; value: RadioOptionValueType }[];
	defaultValue?: RadioOptionValueType;
}

export const FormRadioGroup = ({
	name,
	options,
	defaultValue,
	...radioGroupProps
}: FormRadioGroupProps) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => (
				<RadioGroup
					{...radioGroupProps}
					selectedIndex={findSelectedIndex(options, value)}
					onChange={(index) => {
						onChange(options[index].value);
					}}
				>
					{options.map(({ label, value }) => (
						<Radio key={value}>{label}</Radio>
					))}
				</RadioGroup>
			)}
		/>
	);
};

function findSelectedIndex(options: FormRadioGroupProps['options'], formValue: string | number) {
	return options.findIndex(({ value: optionValue }) => optionValue === formValue);
}
